/* global twttr:false */
class TwitterFeeds {
  constructor() {
    const twitterJS = document.getElementById('tweetjs');

    if (twitterJS) {
      twitterJS.addEventListener('load', () => {
        twttr.ready(() => {
          twttr.events.bind('rendered', (event) => {
              this.init(event.target.contentWindow.document.head);
          });
        });
      });
    }
  }

  init(head) {
    head.insertAdjacentHTML('beforeend', '<style>.timeline-Tweet-text{font-size:16px!important;line-height:20px;}.timeline-Widget{background-color:transparent;}</style>');
  }
}

export default TwitterFeeds;
